<template>
<svg :width="width" :height="height" viewBox="0 0 22 22" class="iconSmileSvg" xmlns="http://www.w3.org/2000/svg">
<path d="M11 0L18.7782 3.22183L22 11L18.7782 18.7782L11 22L3.22183 18.7782L0 11L3.22183 3.22183L11 0Z" fill-opacity="0.3"/>
<path d="M7 13L9.6667 14H12.3333L15 13" stroke="#F9FAFC"/>
<path d="M7 6L8.9021 7.382L8.1756 9.618H5.8244L5.0979 7.382L7 6Z" />
<path d="M15 6L16.9021 7.382L16.1756 9.618H13.8244L13.0979 7.382L15 6Z" />
</svg>

</template>

<script>
export default {
    props: {
        width: { type: [Number, String], default: 22 },
        height: { type: [Number, String], default: 22 },
        color: { type: String, default: "#D3D4DE" }
    }
}
</script>
<style scoped>
    svg{
        fill: var(--icon-svg);
    }
    path{
        stroke: var(--icon-path);
    }
</style>